@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  block-size: 100%;
  overflow: auto;
}

.section {
  display: contents;
}

.header {
}

.main {
  display: grid;
  overflow: auto;
}
.field-group-name-description-module {
  align-items: center;
  grid-template-areas:
    "name-label name-input"
    "description-label description-input"
    "module-label module-entity-selector";
  grid-template-columns: max-content 1fr;
}

.name-label {
  grid-area: name-label;
}
.name-input {
  grid-area: name-input;
}
.description-label {
  grid-area: description-label;
}
.description-input {
  grid-area: description-input;
}
.module-label {
  grid-area: module-label;
}
.module-entity-selector {
  grid-area: module-entity-selector;
}

.tooltip {
  /* WA: Tooltip takes layout space by default, height: 0 prevents layout shift */
  height: 0;
}
